<template>
  <q-card square class="sticky-header-card">
    <div class="center-sticky-header">
      <div class="sticky-sub-menu">
        <div
          class="filter-info"
          style="padding:5px;display:flex;flex-flow:row nowrap;overflow:hidden"
        >
          Filters:
          <q-badge v-if="filterChecker" color="negative">NONE</q-badge>
          <q-badge
            style="margin-right:5px"
            v-if="type && type.value"
            color="positive"
            >Type</q-badge
          >
          <q-badge
            style="margin-right:5px"
            v-if="status && status.val"
            color="info"
            >Status</q-badge
          >
          <q-badge v-if="location_id.length > 0" color="primary"
            >Locations</q-badge
          >
        </div>
      </div>
      <div class="sticky-margin-v3">
        <div style="flex:1"></div>
        <div>
          <q-btn @click="filter = true" round color="grey-7" size="sm">
            <q-icon name="fas fa-caret-down"></q-icon>
          </q-btn>
        </div>
        <div style="margin-left:5px">
          <q-btn
            round
            @click="$store.commit('reports/SET_ADD', true)"
            color="red"
            size="sm"
          >
            <q-icon name="fas fa-plus"></q-icon>
          </q-btn>
        </div>
      </div>
    </div>
  </q-card>
</template>

<script>
import axios from "../axios";
export default {
  mounted() {
    this.getLocations();
  },
  methods: {
    async getLocations() {
      this.loading = true;
      const { data } = await axios.get("locations");
      this.loading = false;
      this.locations = data.data;
    },
    locationFilterPusher(location) {
      if (this.location_id.some((item) => item.id === location.id)) {
        const index = this.location_id
          .map((item) => item.id)
          .indexOf(location.id);
        if (index !== -1) {
          this.$store.commit("reports/REMOVE_LOCATION_ID", index);
        }
      } else {
        this.location_id = [...this.location_id, location];
      }
    },
  },
  computed: {
    filterChecker() {
      if (
        (this.type && this.type.value) ||
        (this.status && this.status.val) ||
        this.location_id.length > 0
      )
        return false;
      else return true;
    },
    filter: {
      get() {
        return this.$store.state.reports.filter;
      },
      set(val) {
        this.$store.commit("reports/SET_FILTER", val);
      },
    },
    types() {
      return this.$store.state.reports.types;
    },
    type: {
      get() {
        return this.$store.state.reports.type;
      },
      set(val) {
        this.$store.commit("reports/SET_TYPE", val);
      },
    },
    loading: {
      get() {
        return this.$store.state.reports.loading;
      },
      set(val) {
        this.$store.commit("reports/SET_LOADING", val);
      },
    },
    shorter() {
      if (this.location_id.length > 0 && this.location_id.length < 2) {
        return this.location_id[0].code;
      } else if (this.location_id.length > 1) {
        return `${this.location_id[0].code} +${this.location_id.length - 1}`;
      }
    },
    location_id: {
      get() {
        return this.$store.state.reports.location_id;
      },
      set(val) {
        this.$store.commit("reports/SET_LOCATION_ID", val);
      },
    },
    locations: {
      get() {
        return this.$store.state.reports.locations;
      },
      set(val) {
        this.$store.commit("reports/SET_LOCATIONS", val);
      },
    },
    status() {
      return this.$store.state.reports.status;
    },
    companies: {
      get() {
        return this.$store.state.company.companies;
      },
      set(val) {
        this.$store.commit("company/SET_USER_COMPANIES", val);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.sticky-margin-v3 {
  display: flex;
  align-items: center;
  margin: 0px 19.7%;
  justify-content: flex-end;
  flex: 0 1 calc(100% - 19.7%);
}
@media only screen and (max-width: 1024px) {
  .sticky-margin-v3 {
    margin: 0px;
    flex: 1;
  }
}
</style>
